import { createSelector } from 'reselect';
import { hasEhrId } from '../shared/person-selectors';
export const selectUser = (state) => state.user;
export const selectHasEhrId = createSelector(selectUser, hasEhrId);
